import React from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import { AddShoppingCart, ShoppingCart } from '@mui/icons-material';
import { useApi } from '../../context/ApiProvider';

const PurchaseButton = ({
  id,
  purchase_url,
  is_purchased,
  artistName,
  trackName,
  size = 'large',
}) => {
  const [isPurchased, setIsPurchased] = React.useState(false);
  const api = useApi();
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    setIsPurchased(is_purchased);
  }, [is_purchased]);

  const getPurchaseUrl = () => {
    if (purchase_url) {
      return purchase_url;
    }
    // Create default Beatport search URL
    const searchQuery = `${encodeURIComponent(
      artistName
    )}%20-%20${encodeURIComponent(trackName)}`;
    return `https://www.beatport.com/search?q=${searchQuery}`;
  };

  const handlePurchaseClick = async () => {
    // Open the new tab with either the provided URL or the default Beatport search
    window.open(getPurchaseUrl(), '_blank');

    // Perform the purchase tracking
    try {
      const response = await api.put(`/favs/track/${id}/purchase`);
      if (response.ok) {
        enqueueSnackbar(`Track bought!`);
      }
      setIsPurchased(true);
    } catch (error) {
      console.error('Error during purchase:', error);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handlePurchaseClick}
      size={size}
      startIcon={
        size === 'small' ? null : isPurchased ? (
          <ShoppingCart />
        ) : (
          <AddShoppingCart />
        )
      }
      sx={{
        borderLeft: '1px solid',
        ...(size === 'small' ? { minWidth: 'auto', px: 1 } : {}),
      }}
    >
      {size === 'small' ? (
        isPurchased ? (
          <ShoppingCart />
        ) : (
          <AddShoppingCart />
        )
      ) : isPurchased ? (
        'Bought'
      ) : (
        'Buy'
      )}
    </Button>
  );
};

PurchaseButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  purchase_url: PropTypes.string,
  is_purchased: PropTypes.boolean,
  artistName: PropTypes.string.isRequired,
  trackName: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default PurchaseButton;
